import {IComponentController, IComponentOptions, IFilterService, IScope, ITimeoutService, RzSlider} from "angular";
import {CustomerFilter} from "../../../customers/model/CustomerFilter";
import './LoanAmountSliderFilterComponent.scss';

interface LoanAmountSliderFilterComponentScope extends IScope {
    showSlider: boolean;
    translateSliderValues: (value: number, sliderId: string, label: string) => any;
    filter: CustomerFilter;
    sliderOptions: RzSlider.RzOptions;
}


export class LoanAmountSliderFilterComponent implements IComponentController {
    private $scope: LoanAmountSliderFilterComponentScope;

    public static instance: IComponentOptions = {
        template: require("./LoanAmountSliderFilterComponent.html"),
        controller: ['$scope', '$filter', LoanAmountSliderFilterComponent],
        bindings: {
            filter: '<',
            opts: '<'
        }
    };

    private filter: CustomerFilter;
    public opts: RangeOptionsDto;

    private $filter: IFilterService;
    private maxPossibleAmountOption: number;
    private $timeout: ITimeoutService;

    constructor($scope: LoanAmountSliderFilterComponentScope,
                $filter: IFilterService) {
        this.$scope = $scope;
        this.$filter = $filter;
        $scope.translateSliderValues = this.translateSliderValues;
        $scope.showSlider = true;
    }

    $onInit(): void {
        this.$scope.filter = this.filter;
        if (this.opts) {
            this.maxPossibleAmountOption = this.opts.maxLoanAmount;

            if (!this.filter.minLoanAmount) this.filter.minLoanAmount = this.opts.minLoanAmount;
            if (!this.filter.maxLoanAmount) this.filter.maxLoanAmount = this.opts.maxLoanAmount;

            this.$scope.sliderOptions = {
                floor: this.opts.minLoanAmount,
                ceil: this.opts.maxLoanAmount,
                step: 1_000,
                translate: this.translateSliderValues
            };
            this.$scope.showSlider = true;
        }
        console.log(this.opts)
    }


    private translateSliderValues: RzSlider.RzTranslate = (value: number, sliderId: string, label: string) => {
        if (value < this.opts.maxLoanAmount)
            return this.$filter('currency')(value, '$', 0);
        else
            return this.$filter('currency')(this.opts.maxLoanAmount, '$', 0) + ' > ';
    }

}
